import React from 'react';
import './../index.css';
import { LevelNav } from './LevelNav';
import { LevelTitle } from './LevelTitle';
import Cookies from 'js-cookies';

const secure = window.location.protocol === 'https';

export class TermsOfUse extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rejected: false,
    }
  }

  setCookie() {
    Cookies.setItem('OA_TOU', '1', { secure: secure });
    this.props.setCookie(true);
    this.setState({
      rejected: false
    });
  }

  unsetCookie() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    Cookies.removeItem('OA_TOU', { secure: secure });
    this.props.setCookie(true);
    this.setState({
      rejected: true
    });
  }


  render() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const title = this.props.title;
    const rejected = this.state.rejected;
    Cookies.setItem('OA_TC', '1', { secure: secure });
    let testCookie = Cookies.getItem('OA_TC', { secure: secure });
    const cookiesEnabled = testCookie === '1';
    const userAgreement = <><div>
      <p>
        <p>
        <b><i>
          All of the documents on this website resource portal (the “Resource Portal”), which are provided by The Alliance for Ending the Fatherless Epidemic
          and Outdoor Adventures Club, are for general informational purposes only. The contents of this Resource Portal are provided in good faith.
        </i></b>
      </p>
      <b><i>WE MAKE NO REPRESENTATION OR WARRANTY WHATSOEVER, EXPRESS OR IMPLIED, REGARDING THE ACCURACY, ADEQUACY, VALIDITY, RELIABILITY, AVAILABILITY OR COMPLETENESS,
      OF <u>ANY INFORMATION</u> CONTAINED IN THIS RESOURCE PORTAL ON WWW.FATHERLESSEPIDEMIC.ORG. WE ARE <u>NOT</u> PROVIDING ANY LEGAL OR BUSINESS ADVICE.
      <br />
      BEFORE RELYING ON ANY INFORMATION OR DOCUMENT, WE <u>HIGHLY RECOMMEND THAT YOU HAVE IT REVIEWED BY YOUR OWN ATTORNEY.</u></i></b>
      </p >
      <p>
        Additionally, in order to honor God and best steward His resources, we require all users of the Resource Portal to agree to the following Statement of Faith:
      </p>
      <ol style={{listStyleType: 'number'}}>
        <li key={'1'}>We believe that the Bible is the inspired and inerrant Word of God and as such allows us to confidently know about 
        God Himself and about how we should live in relationship with Him and others. We stand boldly on the doctrine of Sola Scriptura—that 
        no manmade authority, tradition, experience or institution trumps the authority of Scripture (2 Timothy 3:16-17; Matthew 4:4; 
        Psalm 119:105; John 17:17; Isaiah 40:8; Acts 2:42; John 16:13). Additionally, we believe in adhering to the standard set forth in 
        Scripture, no matter how unpopular they may appear to a fallen world (John 14:15; Deuteronomy 28:2; Proverbs 14:12; James 1:22; 
        Matthew 7:24-27). For example, we believe that God created two genders: man and woman (Genesis 1:26-27). We also believe that 
        marriage is to be between a man and a woman (Genesis 2:24; Ephesians 5:31).</li>
        <li key={'2'}>We believe that just as God calls us to community with Himself, He Himself is a God of community, existing in the form of 
        the Father, the Son, and the Holy Spirit, all of whom are worthy of equal honor and praise (John 1:1; Colossians 2:9; John 14:16-17; 
        Matthew 28:19). </li>
        <li key={'3'}>We believe that all humankind was created by and for God, but that the human race has consistently chosen its own path away 
        from God, both individually and corporately. The result of humanity's choice has been a broken relationship with 
        God (Genesis 6:5; Ecclesiastes 9:3; Mark 7:21-23; Romans 3:10-19; Romans 8:7-8; Mark 10:18). </li>
        <li key={'4'}>We believe that Jesus Christ lived a sinless life and through His death and resurrection has provided a way for all who trust
         in Him to have their sins forgiven and to enter into relationship with God. We enthusiastically subscribe to the doctrines of 
         Solus Christus (Christ alone is the mediator between God and humanity, and salvation is found only through Him), Sola Fide (Faith alone 
         is the means by which believers are justified before God) and Sola Gratia (Grace alone is the basis of salvation, not human merit) 
         (Romans 3:28; Ephesians 2:8-9; Galatians 2:16; John 14:6; Titus 3:5). </li>
        <li key={'5'}>We believe that simultaneous with an individual's trust in the person and work of Christ, the gift of God's Spirit is given 
        to the individual so that life with God can be lived out by Christ's strength and on His terms. We do not deny the potential for a 
        greater level of indwelling by God’s Spirit after the moment of salvation (Ephesians 1:13-14; Romans 8:9; Acts 8:14-17). </li>
        <li key={'6'}>We believe in life after death for everyone who has lived. Those who have trusted in Christ will enjoy a 
        relationship with Him forever, but those who have not trusted in Him will incur the wrath of a God whose offer of forgiveness 
        and reconciliation has been rejected (Hebrews 9:27; John 3:3; John 3:16; John 14:2; Matthew 25:46 Revelation 21:4; John 5:27). </li>
        <li key={'7'}>We believe that the call of each Christian is to live in obedience to the Lord as they seek to obey God’s Great 
        Commandment, His Great Commission and to pursue holiness (Leviticus 11:44; 1 Peter 1:16; Galatians 6:9; Matthew 28:16-20; 
        Deuteronomy 6:5; Matthew 22:36-40; Ephesians 2:10; Matthew 5:16; James 2:26; Titus 3:8). </li>
        <li key={'8'}>We believe in the continuation of the gifts of the Holy Spirit and the working of miracles by the power of God. 
        We also believe in the continued call of the five-fold ministry (Apostles, Prophets, Evangelists, Pastors and Teachers) for 
        the purpose of equipping God’s saints for the work of the ministry (1 Corinthians 12:4-7; Acts 2:16-18; Romans 12:6-8; 1 
        Peter 4:10; 1 Corinthians 14:1; Ephesians 4:11-16).</li>
        <li key={'9'}>We cheerfully ascribe to the doctrine of Soli Deo Gloria. Glory to God alone is the ultimate purpose 
          of all things, including salvation. (Psalm 29:2; Romans 1:19; Ephesians 2:8-9; John 15:5; Romans 11:35-36). </li>        
      </ol>
    </div >
    </>;
    const rejectedMessage = <div>
      <p  style={{color: 'red'}}>
        We're sorry but you will not be granted access to the content in the Outdoor Adventures Resource Portal without first agreeing to the User Agreement.
      </p>
      {userAgreement}
    </div>;

    return (
      <>
        {
          /* 
           * Terms of Use
           */
        }
        <LevelTitle
          title={title}
        />
        <LevelNav
          parentTitle={''}
          parentIndex={'0.'}
          onLevelClick={''}
          searchValue={'-1'}
          searchChange={''}
        />
        <div className='termsOfUse'>
          <h2>
            <u>USER AGREEMENT</u>
          </h2>
          {!cookiesEnabled &&
            <div>
              <p>
                In order to use the Resource Portal, you must enable cookies
              </p>
            </div>
          }
          {rejected &&
            rejectedMessage
          }
          {!rejected &&
            userAgreement
          }
          {cookiesEnabled &&
            <div>
              <p>
                Please agree with the User Agreement to continue.
              </p>
              <div className='bottonGroup'>
                <button autoFocus className='termsOfUseButton' onClick={() => this.setCookie()}>
                  I Agree
                </button>
                <button className='termsOfUseButton' onClick={() => this.unsetCookie()}>
                  I Disagree
                </button>
              </div>
            </div>
          }
        </div>
      </>
    );
  }


}
